<script>
// Cliente e projeto vinculados — os dois únicos campos editáveis do cabeçalho.
// O componente é burro de propósito: só emite; quem abre os modais dedicados
// (via GlobalBus) continua sendo o cabeçalho.
export default {
  name: 'TranscriptLinkFields',
  props: {
    clientName: { type: String, default: '' },
    projectName: { type: String, default: '' },
  },
  computed: {
    fields() {
      return [
        {
          key: 'client',
          label: 'Cliente',
          value: this.clientName || 'Sem cliente',
          tooltip: 'Alterar cliente vinculado',
          event: 'edit-client',
        },
        {
          key: 'project',
          label: 'Projeto',
          value: this.projectName || 'Sem projeto',
          tooltip: 'Alterar projeto vinculado',
          event: 'edit-project',
        },
      ]
    },
  },
}
</script>

<template>
  <div
    class="transcript-link-fields az-card-bordered no-padding no-shadow d-flex flex-column flex-sm-row"
  >
    <div
      v-for="(field, index) in fields"
      :key="field.key"
      class="transcript-link-fields__column d-flex flex-column az-gap-xsmall px-4 py-3"
      :class="{ 'transcript-link-fields__column--divided': index > 0 }"
    >
      <span class="az-ds-label">{{ field.label }}</span>
      <div class="d-flex align-center az-gap-xsmall">
        <span
          class="az-text-primary az-size-14 font-medium text-truncate"
          :title="field.value"
        >
          {{ field.value }}
        </span>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <button
              v-bind="attrs"
              type="button"
              :aria-label="field.tooltip"
              class="transcript-link-fields__edit az-ds-aux d-inline-flex align-center"
              v-on="on"
              @click="$emit(field.event)"
            >
              <icon-svg name="edit" size="14" />
            </button>
          </template>
          <span>{{ field.tooltip }}</span>
        </v-tooltip>
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
// Borda, raio e sombra vêm do az-card-bordered; aqui fica só o que a classe
// canônica não cobre: o fundo cinza (o card do DS é branco), flex-basis e cursor.
.transcript-link-fields
  background: var(--neutral-50)

  // Sem flex-basis 0 (que o Vuetify não tem) as colunas ficariam do tamanho do
  // conteúdo em vez de metade cada.
  &__column
    flex: 1 1 0
    min-width: 0

    // Empilhado o separador é horizontal; a partir do sm (flex-sm-row) vira
    // vertical entre as duas colunas.
    &--divided
      border-top: 1px solid var(--border-hairline)

      @media (min-width: 600px)
        border-top: 0
        border-left: 1px solid var(--border-hairline)

  // <button> nativo pelo foco/teclado de graça; o reset tira o visual de botão
  // para o lápis ficar do tamanho do ícone, alinhado ao texto do campo.
  &__edit
    padding: 0
    border: 0
    background: none
    color: inherit
    cursor: pointer

  // O v-tooltip envolve o ativador num wrapper 0x0 que ainda conta como item de
  // flex — sem isto o az-gap-xsmall é somado antes E depois do lápis.
  ::v-deep .v-tooltip
    display: contents
</style>
